import { EOnboaringFormStep } from '@constants';

type ValidationConfig = {
  requiredFields: (string | string[])[];
};

export const getStepValidationConfig = (): Record<EOnboaringFormStep, ValidationConfig> => {
  return {
    [EOnboaringFormStep.COMPLETE_PROFILE]: {
      requiredFields: [
        'name',
        'lastName',
        'phone',
        'legalId',
        'birthday',
        'country',
        ['userInfo', 'address'],
        ['userInfo', 'province'],
        ['userInfo', 'city'],
        ['userInfo', 'residenceLocality'],
        ['userInfo', 'streetType'],
        ['userInfo', 'streetNumber'],
        ['userInfo', 'postalCode']
      ]
    },
    [EOnboaringFormStep.COMPLETE_PROFILE_FP]: {
      requiredFields: [
        'name',
        'lastName',
        'secondLastName',
        'phone',
        'legalIdType',
        'legalId',
        'birthday',
        ['userInfo', 'nationality'],
        ['userInfo', 'gender'],
        ['userInfo', 'countryBirth'],
        ['userInfo', 'birthProvince'],
        ['userInfo', 'birthMunicipality'],
        ['userInfo', 'birthLocality'],
        ['userInfo', 'birthLocalityForeign'],
        ['userInfo', 'address'],
        ['userInfo', 'province'],
        ['userInfo', 'city'],
        ['userInfo', 'residenceLocality'],
        ['userInfo', 'streetType'],
        ['userInfo', 'streetNumber'],
        ['userInfo', 'postalCode']
      ]
    },
    [EOnboaringFormStep.YOU_HAVE_MASTER_DEGREE]: {
      requiredFields: [['userInfo', 'hasMasterDegree']]
    },
    [EOnboaringFormStep.DEFINE_YOUR_GOAL]: {
      requiredFields: [
        ['userInfo', 'studyBranch'],
        ['userInfo', 'degree'],
        ['userInfo', 'university'],
        ['userInfo', 'otherDegree'],
        ['userInfo', 'otherUniversity']
      ]
    },
    [EOnboaringFormStep.DEFINE_YOUR_GOAL_FP]: {
      requiredFields: [['userInfo', 'hasSubjectsToValidate']]
    },
    [EOnboaringFormStep.DEFINE_YOUR_GOAL_OPOS]: {
      requiredFields: [['userInfo', 'autonomousCommunity']]
    },
    [EOnboaringFormStep.YOUR_SITUATION]: {
      requiredFields: [
        ['userInfo', 'needVisa'],
        ['userInfo', 'hasCertificateDegree'],
        ['userInfo', 'hasNotesEquivalence']
      ]
    },
    [EOnboaringFormStep.PREPAIR_FOR_THE_CHALLENGE]: {
      requiredFields: [['userInfo', 'autonomousCommunity']]
    },
    [EOnboaringFormStep.SUBJECT_NOTES]: {
      requiredFields: [['userInfo', 'subjects']]
    },
    [EOnboaringFormStep.STUDY_PLAN]: {
      requiredFields: [['planification', 'endDate']]
    },
    [EOnboaringFormStep.STUDY_PLAN_FP]: {
      requiredFields: []
    },
    [EOnboaringFormStep.CONFIRM_PLANIFICATION]: {
      requiredFields: []
    },
    [EOnboaringFormStep.CHOOSE_COURSES]: {
      requiredFields: [['planification', 'subscriptions']]
    },
    [EOnboaringFormStep.DISCOVER_SOURCES]: {
      requiredFields: [['onBoarding', 'discoverySource']]
    },
    [EOnboaringFormStep.CHOSEN_REASONS]: {
      requiredFields: [['onBoarding', 'chosenReason']]
    },
    [EOnboaringFormStep.SIGN_CONTRACT]: {
      requiredFields: []
    }
  };
};
